import { FilterProps } from "./Filters.types";
import { DateRangeFilter } from "./DateRangeFilter/DateRangeFilter";
import { SingleChoiceFilter } from "./SingleChoiceFilter";
import { MultipleChoiceFilter } from "./MultipleChoiceFilter";
import { MultipleChoiceAutocompleteFilter } from "./MultipleChoiceAutocompleteFilter";
import { NumberRangeFilter } from "./NumberRangeFilter";
import { QdsSignatureDataFilter } from "./QdsSignatureDataFilter";
import { DocumentDataFilter } from "./DocumentDataFilter";

export function Filter(props: FilterProps) {
  switch (props.filter.type) {
    case "date-range":
      return <DateRangeFilter {...props} />;
    case "single-choice":
      return <SingleChoiceFilter {...props} />;
    case "multiple-choice":
      return <MultipleChoiceFilter {...props} />;
    case "multiple-choice-autocomplete":
      return <MultipleChoiceAutocompleteFilter {...props} />;
    case "number-range":
      return <NumberRangeFilter {...props} />;
    case "qds-signature-data":
      return <QdsSignatureDataFilter {...props} />;
    case "document-data":
      return <DocumentDataFilter {...props} />;
    default:
      return null;
  }
}
